// extracted by mini-css-extract-plugin
export default {"editHkContent":"CustomEditKey-module--edit-hk-content--3HuXi","editHkEditIcon":"CustomEditKey-module--edit-hk-edit-icon--qHGAT","emptyTxt":"CustomEditKey-module--empty-txt--7bdZa"};